import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auth-form"
export default class extends Controller {
  static targets = ["submitButton", "error", "input"]
  static values = {
    endpoint: String,
    processingText: { type: String, default: "Đang xử lý..." },
    connectionError: { type: String, default: "Lỗi kết nối. Vui lòng thử lại." },
  }

  connect() {
    // Clear individual field error on input
    this.inputTargets.forEach(input => {
      input.addEventListener("input", () => {
        input.classList.remove("field-invalid")
        const field = input.dataset.field
        const errorEl = this.errorTargets.find(el => el.dataset.error === field)
        if (errorEl) {
          errorEl.textContent = ""
          errorEl.classList.add("hidden")
        }
      })
    })
  }

  async submit(e) {
    e.preventDefault()
    this._clearErrors()

    const btn = this.hasSubmitButtonTarget ? this.submitButtonTarget : null
    let originalText = ""
    if (btn) {
      originalText = btn.textContent
      btn.disabled = true
      btn.textContent = this.processingTextValue
    }

    try {
      const formData = new FormData(this.element)
      const res = await fetch(this.endpointValue, {
        method: "POST",
        headers: { "Accept": "application/json" },
        body: formData
      })
      const data = await res.json()

      if (res.status === 422 && data.errors) {
        this._showErrors(data.errors)
        if (btn) {
          btn.disabled = false
          btn.textContent = originalText
        }
        return
      }

      if (data.success) {
        window.location.href = data.redirect || "/account"
      }
    } catch (err) {
      alert(this.connectionErrorValue)
      if (btn) {
        btn.disabled = false
        btn.textContent = originalText
      }
    }
  }

  _clearErrors() {
    this.errorTargets.forEach(el => {
      el.textContent = ""
      el.classList.add("hidden")
    })
    this.inputTargets.forEach(el => {
      el.classList.remove("field-invalid")
    })
  }

  _showErrors(errors) {
    Object.entries(errors).forEach(([field, msg]) => {
      const errorEl = this.errorTargets.find(el => el.dataset.error === field)
      if (errorEl) {
        errorEl.textContent = msg
        errorEl.classList.remove("hidden")
      }
      const inputEl = this.inputTargets.find(el => el.dataset.field === field)
      if (inputEl) {
        inputEl.classList.add("field-invalid")
      }
    })
  }
}
